import axiosClient, { ResponseSuccessTotal } from "../axiosClient"
import { IPermission } from "../login/loginApi"

export interface IMenu {
  id: number,
  name: string,
  menuUrl: string,
  icon: string,
  // loaded: false,
  childrenMenu?: IMenu[]
}

export interface ICategoryCarPermission {
  categoryCarId: number
  categoryCarCode: string
}


export interface IMenuAndPermission {
  dataMenu: IMenu[]
  dataPermission: IPermission[]
  dataCategoryCar: ICategoryCarPermission[]
}



export const getListMenu = async (isRecyclebin?: number) => {
  const url = "menu/list"
  const params = { isRecyclebin }
  const result: ResponseSuccessTotal<IMenu[]> = await axiosClient.get(url, { params })
  return result
}

export const getListMenuByUnitAndPermission = async (unitTempId: number) => {
  const url = "groupPermission/listMenuByUnit"
  const params = { unitTempId }
  const result: ResponseSuccessTotal<IMenuAndPermission> = await axiosClient.get(
    url, {
    params
  }
  )
  return result
}
